import { render, staticRenderFns } from "./WishlistIconComponent.vue?vue&type=template&id=7a415e1a"
import script from "./WishlistIconComponent.vue?vue&type=script&lang=js"
export * from "./WishlistIconComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports